import React from 'react';
import MultiPicklist from './fields/Multipicklist.js';
import Picklist from './fields/Picklist.js';
import SelectionField from './fields/SelectionField.js';
import SearchField from './fields/SearchField.js';
import { InputField, TextAreaField, Checkbox } from './fields/AllFields.js';

export default function Index({
    formData,
    setFormData,
    notSerialized = false,
    customQueryDefaults = [],
    includeAddRowButton = false,
    setNewPartDefaultName = null,
}) {
    const handleInputChange = (index, newValue, newValueName, defaultValue = '') => {
        const updatedFormData = [...formData];
        updatedFormData[index].value = newValue;
        updatedFormData[index].valueName = newValueName;
        setFormData(updatedFormData);

        if (newValue == 'add_new' && setNewPartDefaultName) {
            setNewPartDefaultName(defaultValue);
        }
    };

    if (formData?.length < 1)
        return (
            <div className='flex items-center justify-center mx-auto text-red-500'>
                There was an error please log out and log back in
            </div>
        );

    return (
        <>
            {formData &&
                formData?.length > 0 &&
                formData.map((field, index) => {
                    const commonProps = {
                        key: index,
                        label: field.label,
                        value: field.value,
                        valueName: field.valueName,
                        required: field.required,
                        readOnly: field.readOnly,
                        forceError: field.forceError,
                        clearForceError: () => {
                            const updatedFormData = [...formData];
                            updatedFormData[index].forceError = false;
                            setFormData(updatedFormData);
                        },
                        onChange: (eOrValue) => {
                            const newValue = eOrValue?.target ? eOrValue.target.value : eOrValue;
                            const newValueName = eOrValue?.target ? eOrValue.target.valueName : eOrValue;
                            const defaultValue = eOrValue?.target ? eOrValue.target.defaultValue : null;
                            handleInputChange(index, newValue, newValueName, defaultValue);
                        },
                    };

                    switch (field.type) {
                        case 'textarea':
                            return <TextAreaField {...commonProps} />;

                        case 'date':
                            return <InputField {...commonProps} type={field.type} />;

                        case 'picklist':
                            return (
                                <Picklist
                                    {...commonProps}
                                    values={field.picklistValues}
                                    defaultPicklistValue={field.defaultPicklistValue}
                                />
                            );

                        case 'multipicklist':
                            return <MultiPicklist {...commonProps} values={field.picklistValues} />;

                        case 'boolean':
                            return <Checkbox {...commonProps} />;

                        case 'reference':
                            return <SelectionField {...commonProps} options={field.dropdownData} />;

                        case 'customQuery':
                            return (
                                <SearchField
                                    {...commonProps}
                                    options={field.dropdownData}
                                    tableName={field.tableName}
                                    notSerialized={notSerialized}
                                    customQueryDefaults={customQueryDefaults}
                                    includeAddRowButton={includeAddRowButton}
                                />
                            );

                        case 'double':
                            return <InputField {...commonProps} type={'number'} />;
                        case 'string':
                            return <InputField {...commonProps} type={'text'} />;
                        case '':
                            return <div className='relative my-2'></div>;
                        default:
                            return (
                                <div key={index} className='flex items-center justify-center text-red-500 border'>
                                    Unknown field type
                                </div>
                            );
                    }
                })}
        </>
    );
}
